import React from 'react'
import { DocContainer } from './doc-container'
import { DocPreview } from './doc-preview'
import { useContext } from './context'

export default function Docs() {
  const { posts } = useContext()

  return (
    <DocContainer>
      {posts.map((post) => (
        <DocPreview post={post} key={post?.filePath} />
      ))}
    </DocContainer>
  )
}
